document.addEventListener('submit', async function (e) {
    if (e.target.id !== 'formEditarProduccionInyeccion') return;

    const botonActivo = e.submitter;

    if (!botonActivo || botonActivo.id !== 'btnEditarProduccionInyeccion') {
        return;
    }

    e.preventDefault();

    const formulario = e.target;
    const modalPadre = formulario.closest('.modal');
    const spinner = formulario.querySelector('#spinner');
    const btnEditar = formulario.querySelector('#btnEditarProduccionInyeccion');

    if (!formulario.checkValidity()) {
        formulario.reportValidity();
        return;
    }

    if (btnEditar) btnEditar.disabled = true;
    if (spinner) spinner.style.display = 'inline-block';

    formulario.querySelectorAll('.inputRojo').forEach(function (input) {
        input.classList.remove('inputRojo');
    });

    try {
        const formData = new FormData(formulario, botonActivo);

        const respuesta = await fetch('/api/inyeccion/editar-produccion', {
            method: 'POST',
            body: formData,
            credentials: 'include'
        });

        let json = null;

        try {
            json = await respuesta.json();
        } catch (errorJson) {
            throw new Error('La respuesta del servidor no es JSON válido.');
        }

        if (!respuesta.ok) {
            console.error('Error HTTP:', respuesta.status, json);

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
            } else {
                alert('Error al procesar la solicitud.');
            }

            return;
        }

        if (!json || !json.result) {
            console.error('Respuesta inesperada:', json);

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
            }

            return;
        }

        const resultado = json.result;

        if (resultado.hayErrores) {
            if (Array.isArray(resultado.errores)) {
                resultado.errores.forEach(function (error) {
                    if (typeof lanzarAlerta === 'function') {
                        lanzarAlerta(
                            error.mensaje || 'Error de validación.',
                            error.clase || 'alerta-roja'
                        );
                    }

                    if (error.campo) {
                        const campo = formulario.querySelector('[name="' + error.campo + '"]');
                        if (campo) campo.classList.add('inputRojo');
                    }
                });
            }

            return;
        }

        const inputReporte = formulario.querySelector('#idEncabezadoReporteInyeccion');
        const idReporte = inputReporte ? inputReporte.value : '';

        const params = new URLSearchParams(window.location.search);
        const mes = params.get('mes');
        const anio = params.get('año');
        if (modalPadre) modalPadre.classList.remove('modal--show');

        formulario.reset();

        if (window.location.pathname === '/inyeccion/periodo') {
            if (typeof window.actualizarModalReporteInyeccion === 'function') {
                window.actualizarModalReporteInyeccion(idReporte);
            }
            if (typeof window.actualizarTableroInyeccionPeriodo === 'function') {
                window.actualizarTableroInyeccionPeriodo(mes, anio);
            }
            if (typeof window.actualizarTablaInyeccionPeriodo === 'function') {
                window.actualizarTablaInyeccionPeriodo(mes, anio);
            }
        }

        if (window.location.pathname === '/zona-trabajo') {
            if (typeof window.actualizarZonaTrabajo === 'function') {
                if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            }
            if (typeof window.actualizarModalReporteInyeccion === 'function') {
                window.actualizarModalReporteInyeccion(idReporte);
            }
        }

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Registro editado con éxito.', 'alerta-verde');
        }

    } catch (error) {
        console.error('Error:', error);

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } else {
            alert('Error crítico al procesar la solicitud.');
        }

    } finally {
        if (btnEditar) btnEditar.disabled = false;
        if (spinner) spinner.style.display = 'none';
    }
});